import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  ConfirmationNumber,
  Queue
} from "@mui/icons-material";
import React, { memo } from "react";
import TextField from "@mui/material/TextField";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";
import { Typography } from "@material-ui/core";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  // console.log(12, "ticketNode", data);
  return (
    <div
      style={{
        backgroundColor: "#f0f9ff",
        padding: "8px",
        borderRadius: "14px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #bae6fd",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#0ea5e9",
          width: "14px",
          height: "14px",
          top: "20px",
          left: "-9px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
      </div>
      <div
        style={{
          color: "#111827",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <Queue
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "3px",
            color: "#0ea5e9",
          }}
        />
        <div style={{ color: "#111827", fontSize: "16px" }}>Fila</div>
      </div>
      <div style={{ color: "#374151", fontSize: "12px", width: 180 }}>
        <div
          style={{
            backgroundColor: "#e0f2fe",
            marginBottom: "3px",
            borderRadius: "8px",
            padding: "6px",
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "10px",
              color: "#0c4a6e",
              textAlign: "center",
            }}
          >
            {data.queue.name}
          </div>
        </div>
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#0ea5e9",
          width: "14px",
          height: "14px",
          top: "70%",
          right: "-9px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
